import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';

import DangerousHTML from 'Components/Utility/DangerousHTML';
import ProductRequirements from 'Helpers/Product/ProductRequirements';

import 'Components/Product/SystemRequirements/SystemRequirements.scss';

const SystemRequirements = ({
  ztormGame,
  fullWidth,
  showTitle,
  catalina,
  systems,
  requirements: { win, lin, mac },
}) => {
  const requirements = { windows: win, linux: lin, mac };
  const [tab, setTab] = useState(0);

  const toggleTab = (tabToSet) => {
    setTab(tabToSet);
  };

  const renderRequirementTab = (index, platform) => {
    const product = {
      catalina,
      platforms: systems,
    };
    const showCatalina = ProductRequirements.CatalinaSupported(product);
    const { min, rec } = requirements[platform];
    return (
      <TabPane tabId={index} key={platform}>
        {showTitle &&
          <h3 className="section-heading">
            <FormattedMessage id="system.requirements-title" defaultMessage="Product Requirements" />
          </h3>
        }

        {showCatalina && platform === 'mac' &&
          <div className="catalina-warning">
            <span className="please-note"><FormattedMessage id="system.catalina.pleasenote" defaultMessage="Please Note: " /></span>
            <FormattedMessage id="system.catalina.message" defaultMessage="This product is not compatible with macOS Catalina 10.15 or later. " />
            <a href="https://support.fanatical.com/hc/en-us/articles/360006891898" className="brand-link">
              <FormattedMessage id="system.catalina.findoutlink" defaultMessage="Find out more" />
            </a>
          </div>
        }


        {!ztormGame &&
          <div className="row">
            {min && <div className={fullWidth ? 'col-md-12 requirements-column' : 'col-md-6 requirements-column'}>{min && <DangerousHTML tag="p" html={min} />}</div>}
            {rec && <div className={fullWidth ? 'col-md-12 requirements-column' : 'col-md-6 requirements-column'}>{rec && <DangerousHTML tag="p" html={rec} />}</div>}
          </div>
        }

        {ztormGame &&
          <div className="row">
            {min && <div className="col-md-12">{<DangerousHTML tag="p" html={min} />}</div>}
            {rec && <div className="col-md-12">{<DangerousHTML tag="p" html={rec} />}</div>}
          </div>
        }
      </TabPane>
    );
  };

  return (
    <div className="system-requirements pt-2">
      {!ztormGame && <Nav tabs>
        {Object
          .keys(systems)
          .filter(p => requirements[p] && systems[p])
          .sort()
          .reverse()
          .map((platform, i) =>
            <NavItem className="mr-1 mb-0" key={platform}>
              <NavLink
                href="#"
                className={classNames({ active: tab === i }, 'text-capitalize', 'px-4 py-2')}
                onClick={() => toggleTab(i)}
              >
                {platform === 'windows' &&
                  <div>
                    <FontAwesomeIcon icon={fabFaWindows} className="sys-req-icon mr-1" />
                    <FormattedMessage id="sysreqs.windows" defaultMessage="Windows" />
                  </div>
                }
                {platform === 'mac' &&
                  <div>
                    <FontAwesomeIcon icon={fabFaApple} className="sys-req-icon mr-1" />
                    <FormattedMessage id="sysreqs.mac" defaultMessage="Mac" />
                  </div>
                }
                {platform === 'linux' &&
                  <div>
                    <FontAwesomeIcon icon={fabFaLinux} className="sys-req-icon mr-1" />
                    <FormattedMessage id="sysreqs.linux" defaultMessage="Linux" />
                  </div>
                }
              </NavLink>
            </NavItem>,
          )}
      </Nav>}

      <TabContent activeTab={tab} className="p-4">
        {
          Object
            .keys(requirements)
            .filter(p => requirements[p] && systems[p])
            .sort()
            .reverse()
            .map((platform, i) => renderRequirementTab(
              i, platform))
        }
      </TabContent>
    </div>
  );
};

const requirementPropType = PropTypes.shape({
  min: PropTypes.string,
  rec: PropTypes.string,
});

SystemRequirements.propTypes = {
  systems: PropTypes.shape({
    windows: PropTypes.bool,
    mac: PropTypes.bool,
    linux: PropTypes.bool,
  }),
  requirements: PropTypes.shape({
    win: requirementPropType,
    lin: requirementPropType,
    mac: requirementPropType,
  }),
  ztormGame: PropTypes.bool,
  catalina: PropTypes.bool,
  fullWidth: PropTypes.bool,
  showTitle: PropTypes.bool,
};

SystemRequirements.defaultProps = {
  ztormGame: false,
  fullWidth: false,
  showTitle: true,
  catalina: false,
  systems: {
    windows: false,
    mac: false,
    linux: false,
  },
  requirements: {},
};

export default SystemRequirements;
